import { createUseStyles } from "react-jss";
import { SPACING } from "../../../constants/styleGuide";

export const AddBudgetByPhaseStyles = createUseStyles({
  budgetTypePhase: {
    paddingTop: SPACING.s16,
    '& .MuiToolbar-root': {
      display: "none"
    },
  },
  addPhase: {
    padding: SPACING.s16,
    backgroundColor: "#f8f8f8",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  addNewText: {
    color: "#000000",
    fontSize: "12px",
    lineHeight: 1.33,
    paddingLeft: "10px",
  },
  phaseTable: {
    "& .MuiPaper-root": {
      boxShadow: "none",
      border: "1px solid #e0e0e0",
      borderRadius: "8px"
    },
    "& .MuiTableHead-root": {
      backgroundColor: "#f5f5f5"
    },
    "& .MuiTableCell-head": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#2e2f32",
      padding: "12px 16px"
    },
    "& .MuiTableCell-body": {
      fontSize: "14px",
      color: "#2e2f32",
      padding: "12px 16px"
    },
    "& .MuiTableRow-root:hover": {
      backgroundColor: "#f9f9f9"
    }
  }
});